// extracted by mini-css-extract-plugin
export default {"errorAccessContainer":"errorAccessContainer__OljNc","errorAccessTextLabel":"errorAccessTextLabel__JQ1nR"};